import "./Gallery.scss";

const gallery = [
  "/assets/images/gallery-1.webp",
  "/assets/images/gallery-2.webp",
  "/assets/images/gallery-3.webp",
  "/assets/images/gallery-4.webp",
  "/assets/images/gallery-5.webp",
  "/assets/images/collage.webp"
];

export default function Gallery() {
  return (
    <section className="gallery section" id="gallery">
      <div className="section-header">
        <span className="section-eyebrow">Gallery</span>
        {/* <h2 className="section-title">Add your best demo, booth, and component photos here.</h2> */}
      </div>

      <div className="gallery__grid">
        {gallery.map((file, index) => (
          <div className={`gallery__item gallery__item--${index + 1}`} key={file}>
            <img src={file} alt="" />
            {/* <div className="image-placeholder">
              <div>
                <strong>Gallery Image {index + 1}</strong>
                <small>Replace: {file}</small>
              </div>
            </div> */}
          </div>
        ))}
      </div>
    </section>
  );
}
